<template>
    <div>
        <el-collapse v-if="task_list.length > 0" v-model="activeNames">
            <template v-for="(item, index) in task_list">
                <el-collapse-item :title="item.task_name" :name="index" :key="item.id" style="border:1px solid #eeeeee;border-radius:5px;margin-top:17px;">
                    <template slot="title">
                        <div class="collapse_title">
                            <span style="color:#ffaa2c;font-size:12px;border:1px solid #ffd18c;border-radius:5px;height:24px;line-height:24px;background:#fff9ef;padding:0 5px;" class="item">{{ item.valid_status }}</span>
                            <span style="color:#333333;margin-left:10px;font-size:14px;font-weight:normal;" class="item">{{ item.task_name }}</span>
                            <span style="color:#aaaaaa;font-size:14px;margin-right:25px;font-weight:normal;" class="item">({{ item.effective_date }} ~ {{ item.expiration_date }})</span>
                        </div>
                    </template>
                    <div style="padding:0 20px;">
                        <el-table
                        :data="item.todolist"
                        style="width: 100%"
                        v-if="item.is_superior=='否'">
                            <el-table-column type="index"></el-table-column>
                            <el-table-column prop="type" label="调研类型" min-width="75%"></el-table-column>
                            <el-table-column prop="status" label="完成状态" min-width="10%">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.status=='未开始'" class="not_start">未开始</div>
                                    <div v-if="scope.row.status=='进行中'" class="in_process">进行中</div>
                                    <div v-if="scope.row.status=='已提交'" class="started">已提交</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="operations" label="操作" min-width="10%">
                                <template slot-scope="scope">
                                    <el-button
                                    v-if="scope.row.status=='未开始'"
                                    size="mini"
                                    type="primary" 
                                    @click="start_evaluating(scope.row, item.id, item.task_name, item.is_superior)">开始调研</el-button>
                                    <el-button
                                    v-if="scope.row.status=='进行中'"
                                    size="mini"
                                    type="primary" 
                                    @click="start_evaluating(scope.row, item.id, item.task_name, item.is_superior)">继续调研</el-button>
                                    <el-button
                                    v-if="scope.row.status=='已提交'"
                                    size="mini"
                                    type="primary" 
                                    @click="start_evaluating(scope.row, item.id, item.task_name, item.is_superior)">查看详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-table
                        :data="item.todolist"
                        style="width: 100%"
                        :span-method="objectSpanMethod"
                        v-else>
                            <el-table-column type="index"></el-table-column>
                            <el-table-column prop="name" label="下属姓名" min-width="10%"></el-table-column>
                            <el-table-column prop="type" label="调研类型" min-width="50%"></el-table-column>
                            <el-table-column prop="submit_date" label="提交时间" min-width="15%"></el-table-column>
                            <el-table-column prop="status" label="完成状态" min-width="10%">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.status=='未开始'" class="not_start">未开始</div>
                                    <div v-if="scope.row.status=='进行中'" class="in_process">进行中</div>
                                    <div v-if="scope.row.status=='已提交'" class="started">已提交</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="operations" label="操作" min-width="10%">
                                <template slot-scope="scope">
                                    <el-button
                                    v-if="scope.row.status=='未开始' && scope.row.enable==true"
                                    size="mini"
                                    type="primary" 
                                    @click="start_evaluating(scope.row, item.id, item.task_name, item.is_superior)">开始调研</el-button>
                                    <el-tooltip effect="light" content="待所有下属完成该评估后解锁" placement="top-end">
                                        <el-button
                                        v-if="scope.row.status=='未开始' && scope.row.enable==false"
                                        size="mini"
                                        type="primary"
                                        disabled 
                                        @click="start_evaluating(scope.row, item.id, item.task_name, item.is_superior)">开始调研</el-button>
                                    </el-tooltip>
                                    <el-button
                                    v-if="scope.row.status=='进行中'"
                                    size="mini"
                                    type="primary" 
                                    @click="start_evaluating(scope.row, item.id, item.task_name, item.is_superior)">继续调研</el-button>
                                    <el-button
                                    v-if="scope.row.status=='已提交'"
                                    size="mini"
                                    type="primary" 
                                    @click="start_evaluating(scope.row, item.id, item.task_name, item.is_superior)">查看详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-collapse-item>
            </template>
        </el-collapse>
        <!-- 原来的dialog宽度是1350px -->
        <el-dialog 
        title="" 
        :visible.sync="dialogFormVisible" 
        width="1000px" 
        :destroy-on-close="true" 
        :close-on-click-modal="false"
        class="motivation_dialog"
        @open="init_motivation">
            <!-- 这里直接引用scope.row中的属性无效，所以用form引用该row，通过form去引用对应的元素 -->
            <template slot="title">
                <span style="font-weight:bold;font-size:18px;">工作动机重要性及满意度评估</span>
                <!-- <span style="font-weight:bold;font-size:18px;color:#409EFF;">{{ form.date }}</span> -->
                <transition name="fade">
                    <span v-if="show" style="font-size:16px;color:#909399;margin-left:10px;">数据已自动保存！</span>
                </transition>
            </template>
            <div style="text-align:left;font-size:16px;color:#67C23A;margin-bottom:15px;">
                <p style="margin: 0px;">
                    <span v-if="form.role=='superior'">请您仔细回忆与下属 <span style="font-weight:bold;">{{ form.name }}</span> 的日常沟通以及激励方式，选出在您看来下属 <span style="font-weight:bold;">{{ form.name }}</span> 对以下工作动机的重要程度和满意程度：</span>
                    <span v-else>请填写以下表格，打勾选出对上级沟通方式及协作行为感知的重要程度和满意程度：</span>
                </p>
            </div>
            <!-- 这里通过sendData监听子组件的$emit方法，并通过父组件的getData方法获取子组件传递的数据 -->
            <motiv-mana 
            ref="motiv_mana" 
            @sendData="submitMotivationResults"  
            :error_flag="error_flag"
            :submit_times="submit_times"
            :is_view="form.status=='已提交'">
            </motiv-mana>
            <!-- <div style="text-align:left;font-size:16px;color:#67C23A;margin-bottom:15px;margin-top:20px;" v-if="!form.name">
                <p style="margin: 0px;">
                    <span>对于以下激励资源，请填写您上级的使用频率：</span>
                </p>
            </div> -->
            <!-- <resour-mana 
            ref="resour_mana" 
            :resource_info="resource_info" 
            v-if="!form.name">
            </resour-mana> -->
            <!-- 按钮的显示，增加一个motivation_info.length的条件，只有当问卷加载成功后才显示，防止一闪的时候显示按钮 -->
            <div style="text-align:center;margin-top:15px;" v-if="(form.status=='未开始' || form.status=='进行中')">
            <!-- <div style="text-align:center;"> -->
                <el-button @click="dialogSave">保 存</el-button>
                <el-button type="primary" @click="dialogSubmit">提 交</el-button>
                <!-- <el-button type="primary" @click="dialogSubmit" v-if="form.status=='已完成'">更 新</el-button> -->
            </div>
        </el-dialog>
        <el-dialog 
        title="" 
        :visible.sync="dialogFormVisible_behavior" 
        width="1000px" 
        :destroy-on-close="true" 
        :close-on-click-modal="false">
            <!-- 这里直接引用scope.row中的属性无效，所以用form引用该row，通过form去引用对应的元素 -->
            <template slot="title">
                <span style="font-weight:bold;font-size:18px;">下属离职倾向识别</span>
                <!-- <span style="font-weight:bold;font-size:18px;color:#409EFF;">{{ form.date }}</span> -->
                <transition name="fade">
                    <span v-if="show" style="font-size:16px;color:#909399;margin-left:10px;">数据已自动保存！</span>
                </transition>
            </template>
            <div style="padding-left:20px;padding-right:20px;text-align:left;font-size:16px;color:#67C23A;">
                <p style="margin: 0px;">
                    <span style="margin-bottom:15px;">请您仔细回忆下属 <span style="font-weight:bold;">{{ form.name }}</span> 的近期行为表现，对是否出现过以下行为做出判断（尤其关注之前没有类似行为，在近期突然出现的异常行为）：</span>
                </p>
            </div>
            <!-- 这里通过sendData监听子组件的$emit方法，并通过父组件的getData方法获取子组件传递的数据 -->
            <behav-mana 
            ref="behav_mana" 
            @sendData="submitBehaviorResults" 
            :behavior_info="behavior_info" 
            :error_flag="error_flag"
            :submit_times="submit_times"
            :is_view="form.status=='已提交'">
            </behav-mana>
            <!-- 按钮的显示，增加一个behavior_info.length的条件，只有当问卷加载成功后才显示，防止一闪的时候显示按钮 -->
            <div style="text-align:center;margin-top:15px;" v-if="(form.status=='未开始' || form.status=='进行中') && this.behavior_info.length > 0">
            <!-- <div style="text-align:center;"> -->
                <el-button @click="dialogSave_behavior">保 存</el-button>
                <el-button type="primary" @click="dialogSubmit_behavior">提 交</el-button>
                <!-- <el-button type="primary" @click="dialogSubmit" v-if="form.status=='已完成'">更 新</el-button> -->
            </div>
        </el-dialog>
        <el-dialog 
        title="" 
        :visible.sync="dialogFormVisible_resource" 
        width="1000px" 
        :destroy-on-close="true" 
        :close-on-click-modal="false">
            <!-- 这里直接引用scope.row中的属性无效，所以用form引用该row，通过form去引用对应的元素 -->
            <template slot="title">
                <span style="font-weight:bold;font-size:18px;">激励资源评估</span>
                <!-- <span style="font-weight:bold;font-size:18px;color:#409EFF;">{{ form.date }}</span> -->
                <transition name="fade">
                    <span v-if="show" style="font-size:16px;color:#909399;margin-left:10px;">数据已自动保存！</span>
                </transition>
            </template>
            <div style="text-align:left;font-size:16px;color:#67C23A;margin-bottom:15px;">
                <p style="margin: 0px;">
                    <span v-if="form.role=='subordinate'">对于以下激励资源，请填写您上级的使用频率：</span>
                    <span v-else>对于以下激励资源，请填写您的使用频率：</span>
                </p>
            </div>
            <!-- 这里通过sendData监听子组件的$emit方法，并通过父组件的getData方法获取子组件传递的数据 -->
            <resour-mana 
            ref="resour_mana" 
            @sendData="submitResourceResults" 
            :resource_info="resource_info" 
            :error_flag_resource="error_flag_resource"
            :submit_times="submit_times"
            :is_view="form.status=='已提交'">
            </resour-mana>
            <!-- 按钮的显示，增加一个resource_info.length的条件，只有当问卷加载成功后才显示，防止一闪的时候显示按钮 -->
            <div style="text-align:center;margin-top:15px;" v-if="(form.status=='未开始' || form.status=='进行中') && this.resource_info.length > 0">
            <!-- <div style="text-align:center;"> -->
                <el-button @click="dialogSave_resource">保 存</el-button>
                <el-button type="primary" @click="dialogSubmit_resource">提 交</el-button>
                <!-- <el-button type="primary" @click="dialogSubmit" v-if="form.status=='已完成'">更 新</el-button> -->
            </div>
        </el-dialog>
        <div class="no_task" v-if="task_list.length <= 0">
            <span>暂无待完成的任务。</span>
        </div>
    </div>
</template>

<script>
import motivMana from "../QuestionManagement/RC_motivation.vue";
import behavMana from "../QuestionManagement/RC_behavior.vue";
import resourMana from "../QuestionManagement/RC_resource.vue";
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
export default {
    created() {
        this.getToDoList();
    },
    // beforeUpdate() {
    //     this.display_flag = true;
    // },
    components: {
        motivMana,
        behavMana,
        resourMana,
    },
    data() {
        return {
            task_list: [],
            form: {},
            dialogFormVisible: false,
            dialogFormVisible_behavior: false,
            dialogFormVisible_resource: false,
            submit_question_info: [],
            submit_survey_info: [],
            qid_list: [],
            result_list: [],
            request_info: {},
            unfinish_num: 0,
            question_info: [],
            survey_info: [],
            proof_info: [],
            check_flag: true,
            error_flag: false,  //标识检查是否有错误，用于标红未答的主观题（行为问卷）
            error_flag_resource: false,  //标识检查是否有错误，用于标红未答的主观题（激励资源问卷）
            check_flag_survey: true,
            error_flag_survey: false,  //标识检查是否有错误，用于标红未答的主观题
            login_random_series: null,
            login_task_id: null,
            timer: null,
            timer2: null,
            timer_flag: false,      // 定时器状态：false销毁定时器，true打开定时器
            show: false,
            submit_times: 0,        // 问卷提交次数，当次数>0时，表示问卷有问题提交失败，此时重选错误的题目可以触发重新检测
            motivation_info_props: [],
            behavior_info: [],
            resource_info: [],
            // relatively_dissatisfied_num: 0,
            // quite_satisfied_num: 0,
            // very_satisfied_num: 0,
            // relatively_important_num: 0,
            // quite_important_num: 0,
            // very_important_num: 0,
            // relatively_dissatisfied_motivations: [],
            // very_important_motivations: [],
            active_task_id: null,
            active_task_status: null,
            active_user_id: null,
            activeNames: [],
        };
    },
    methods: {
        dialogSave() {
            this.$refs.motiv_mana.saveMotivation();
        },
        dialogSave_behavior() {
            this.$refs.behav_mana.saveBehavior();
        },
        dialogSave_resource() {
            this.$refs.resour_mana.saveResource();
        },
        dialogSubmit_resource() {
            this.$refs.resour_mana.submitResource();
        },
        // 执行单元格合并
        objectSpanMethod({ row, column, rowIndex, columnIndex }){
            // console.log(column, rowIndex, columnIndex);
            if(columnIndex==0 || columnIndex==1){
                return [row.RowSpan, row.ColumnSpan];
            }
        },
        handle_close() {
            // 仅在存在定时任务且有答题记录的情况下，关闭dialog才会触发提交关闭前的最后记录
            if(this.timer_flag==true){
                this.$refs.survey_mana.submitManaQues_timer();
                this.getToDoList();
            }
        },
        start_interval(status) {
            if(status!='已提交'){
                this.timer_flag = true;     // 只在调研未完成的情况下才开启定时提交任务
            }else{
                this.timer_flag = false;
                return;
            }
            // let i = 0;
            this.timer = setInterval(() => {
                if(this.timer_flag==false) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
                this.$refs.survey_mana.submitManaQues_timer();
                // console.log('i: ' + i);
                // i = i + 1;
                //需要定时执行的代码
            },10000)
        },
        clear_interval() {
            this.timer_flag = false;        //关闭对话框时，销毁定时任务
            clearInterval(this.timer);
            this.timer = null;
        },
        init_motivation() {
            if(this.active_task_status == '未开始'){
                this.$nextTick(() => {
                    this.$refs.motiv_mana.getRCMotivation(this.active_task_id);
                })
            }else{
                this.$nextTick(() => {
                    this.$refs.motiv_mana.getRCMotivationResults(this.active_task_id, this.active_user_id);
                })
            }                         
        },
        start_evaluating(row, task_id, task_name, is_superior) {
            // this.active_task_id = task_id;
            // this.form = row;
            // this.form['task_id'] = task_id;
            // this.active_task_status = this.form['status'];
            // this.active_user_id = this.form['user_id'];     // 被评估人id
            // this.submit_times = 0;
            // 改用从父组件直接从后台获取问卷信息，并传给子组件
            if(row.type=='工作动机重要性及满意度评估'){
                //this.$refs.motiv_mana.getRCMotivation(task_id);
                // this.form = row;
                // if(!this.form.name){
                //     this.getRCResource(task_id);
                // }
                // 增加task_id的获取，提交问卷需要补充task_id
                // this.form['task_id'] = task_id;
                // this.dialogFormVisible = true;
                // this.submit_times = 0;
                // this.dialogFormVisible = true;
                this.$router.push({
                    name: 'MyRCAssTask',
                    query: {
                        taskid: task_id,
                        task_name: task_name,
                        type: row.type,
                        ass: row.name,
                        rid: row.user_id,
                        status: row.status,
                        superior: is_superior,
                    }
                })
            }
            else if(row.type=='激励资源评估'){               
                // if(this.active_task_status == '未开始'){
                //     this.getRCResource(task_id);
                // }else{
                //     this.getRCResourceResults(task_id);
                // }
                this.$router.push({
                    name: 'MyRCAssTask',
                    query: {
                        taskid: task_id,
                        task_name: task_name,
                        type: row.type,
                        ass: row.name,
                        rid: row.user_id,
                        status: row.status,
                        superior: is_superior,
                    }
                })
            }
            else if(row.type=='下属离职倾向识别'){
                // if(this.active_task_status == '未开始'){
                //     this.getRCBehavior(task_id);
                // }else{
                //     this.getRCBehaviorResults(task_id);
                // }
                this.$router.push({
                    name: 'MyRCAssTask',
                    query: {
                        taskid: task_id,
                        task_name: task_name,
                        type: row.type,
                        ass: row.name,
                        rid: row.user_id,
                        status: row.status,
                        superior: is_superior,
                    }
                })
                // this.form = row;
                // 增加task_id的获取，提交问卷需要补充task_id
                // this.form['task_id'] = task_id;
                // this.dialogFormVisible_behavior = true;
                // this.submit_times = 0;
            }  
        },
        view_details(row, task_id) {
            // 改用从父组件直接从后台获取问卷信息，并传给子组件
            if(row.type=='工作动机重要性及满意度评估'){
                this.getRCMotivationResults(task_id);
            }else{
                return; //预留
            }
            // 如果是查询详情，则需要使用被评估人id和评估类型，从后台获取评估结果进行展示
            // this.getResultByUser(row.id, row.type, task_id);
            this.form = row;
            // 查询页增加更新功能后，也需要补充task_id
            this.form['task_id'] = task_id;
            // this.dialogFormVisible = true;
            this.submit_times = 0;
        },
        getRCMotivationResults(task_id) {
            let params = {
                task_id: task_id,
            }
            getdata.getListP("getMotivationResults", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.motivation_info_props = resp.data.data;
                    this.dialogFormVisible = true;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getRCBehaviorResults() {
            let params = {
                task_id: this.active_task_id,
                user_id: this.active_user_id, 
            }
            getdata.getListP("getBehaviorResults", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.behavior_info = resp.data.data;
                    this.dialogFormVisible_behavior = true;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getRCResourceResults() {
            let params = {
                task_id: this.active_task_id,
                user_id: this.active_user_id, 
            }
            getdata.getListP("getResourceResults", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.resource_info = resp.data.data;
                    this.dialogFormVisible_resource = true;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        dialogCancel() {
            this.dialogFormVisible = false;
        },
        dialogCancel_behavior() {
            this.dialogFormVisible_behavior = false;
        },
        dialogSubmit() {
            // this.timer_flag = false;        //点击按钮提交问卷时，同样销毁定时任务---修改为提交成功才进行销毁
            // clearInterval(this.timer);
            // this.timer = null;
            // 触发子组件的$emit方法向父组件传递数据
            this.$refs.motiv_mana.submitMotivation();
            // 答题不完整，check_flag会被设置为false，则终止提交
            // if(this.check_flag == false){
            //     return;
            // }
            // this.dialogFormVisible = false;
            // 提交问卷后，需要刷新当前评估人的评估状态数据，以及更新待处理评估数
            // this.getToDoList();
            // this.updateToDoNum();
        },
        dialogSubmit_behavior() {
            // 触发子组件的$emit方法向父组件传递数据
            this.$refs.behav_mana.submitBehavior();
            // 答题不完整，check_flag会被设置为false，则终止提交
            // if(this.check_flag == false){
            //     return;
            // }
            // this.dialogFormVisible_survey = false;
            // 提交问卷后，需要刷新当前评估人的评估状态数据，以及更新待处理评估数
            // this.getToDoList();
            // this.updateToDoNum();
        },
        checkManaQues() {
            for(var cg in this.submit_question_info){
                for(var sj in this.submit_question_info[cg]['subject']){
                    if(this.submit_question_info[cg]['subject'][sj]['selected_option'] == ''){
                        this.$message({
                            message: '有未完成的答题，请检查！',
                            type: 'error',
                            duration: 6000,
                            // showClose: true,
                        })
                        this.check_flag = false;
                        this.error_flag = true;
                        console.log("this.error_flag: " + this.error_flag);
                        return;
                    }
                }
            }
            // 如果检查没问题，重新赋值check_flag为true
            this.check_flag = true;
            this.error_flag = false;
            console.log("this.error_flag: " + this.error_flag);
        },
        checkManaSurvey() {
            for(var i in this.submit_survey_info){
                if(this.submit_survey_info[i]['choice_type']=='多选' && this.submit_survey_info[i]['selected_option']=='其他'){
                    if(!this.submit_survey_info[i]['proof']){
                        this.$message({
                            message: '有未完成的答题，请检查！',
                            type: 'error',
                            duration: 6000,
                            // showClose: true,
                        })
                        this.check_flag_survey = false;
                        this.error_flag_survey = true;
                        console.log("this.error_flag_survey: " + this.error_flag_survey);
                        return;
                    }
                }else{
                    if(this.submit_survey_info[i]['selected_option'] == ''){
                        this.$message({
                            message: '有未完成的答题，请检查！',
                            type: 'error',
                            duration: 6000,
                            // showClose: true,
                        })
                        this.check_flag_survey = false;
                        this.error_flag_survey = true;
                        console.log("this.error_flag_survey: " + this.error_flag_survey);
                        return;
                    }
                }
            }
            // 如果检查没问题，重新赋值check_flag为true
            this.check_flag_survey = true;
            this.error_flag_survey = false;
        },
        // 父组件获取子组件传递的问卷结果信息
        submitMotivationResults(data) {
            if(data[4] == false){
                this.$message({
                    message: '勾选项数量与要求的数量不一致，请检查！',
                    type: 'error',
                    duration: 6000,
                    // showClose: true,
                })
            }else{
                // 处理问卷结果信息，并提交后台处理
                // 提交问卷前，需要先检查是否有未完成的题目（主要是选择题）---定时任务提交时不做检查
                // if(this.timer_flag==false){
                let save_mode = 'save';
                let submit_data = {'motivation_info': data[0]};
                submit_data['relatively_dissatisfied_motivations'] = data[2];
                submit_data['very_important_motivations'] = data[3];
                let api_name = "saveMotivationResults";
                if(data[1]=='submit'){
                    save_mode = 'submit';
                    // 检查待补充
                    // this.checkManaQues();
                    // if(this.check_flag == false){
                    //     return;
                    // }
                }
                let params = {
                    'task_id': this.form['task_id'],
                    'save_mode': save_mode,
                    'user_id': this.active_user_id,
                };
                postdata.postListP(api_name, JSON.stringify(submit_data), params)
                .then(resp => {
                    if(resp.data.code == 200){
                        if(save_mode == 'save'){
                            this.$message({
                            message: '保存成功！',
                            type: "success",
                            })
                            this.form['status'] = '进行中';                   
                        }else{
                            this.$message({
                            message: '提交成功！',
                            type: "success",
                            })
                            this.getToDoList();
                            this.dialogFormVisible = false;
                        }                    
                    }
                })
                .catch(err => {
                    console.log(err);
                })
            }
        },
        submitBehaviorResults(data) {
            let save_mode = 'save';
            let api_name = "saveBehaviorResults";
            if(data[1]=='submit'){
                save_mode = 'submit';
                // 检查未填项
                this.error_flag = false;
                for(var i in data[0]){
                    if(data[0][i]['selected_option'] == ''){
                        this.error_flag = true;
                        this.$message({
                        message: '有未完成的答题，请检查！',
                        type: 'error',
                        duration: 6000,
                        })
                        return;
                    }
                }
            }
            let params = {
                'task_id': this.form['task_id'],
                'save_mode': save_mode,
                'user_id': this.active_user_id,
            };
            postdata.postListP(api_name, JSON.stringify(data[0]), params)
              .then(resp => {
                if(resp.data.code == 200){
                    if(save_mode == 'save'){
                        this.$message({
                        message: '保存成功！',
                        type: "success",
                        })
                        this.form['status'] = '进行中';                   
                    }else{
                        this.$message({
                        message: '提交成功！',
                        type: "success",
                        })
                        this.getToDoList();
                        this.dialogFormVisible_behavior = false;
                    }                    
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        submitResourceResults(data) {
            let save_mode = 'save';
            let api_name = "saveResourceResults";
            if(data[1]=='submit'){
                save_mode = 'submit';
                // 检查未填项
                this.error_flag_resource = false;
                for(var i in data[0]){
                    if(data[0][i]['freq'] == ''){
                        this.error_flag_resource = true;
                        this.$message({
                        message: '有未完成的答题，请检查！',
                        type: 'error',
                        duration: 6000,
                        })
                        return;
                    }
                }
            }
            let params = {
                'task_id': this.form['task_id'],
                'save_mode': save_mode,
                'user_id': this.active_user_id,
            };
            postdata.postListP(api_name, JSON.stringify(data[0]), params)
              .then(resp => {
                if(resp.data.code == 200){
                    if(save_mode == 'save'){
                        this.$message({
                        message: '保存成功！',
                        type: "success",
                        })
                        this.form['status'] = '进行中';                   
                    }else{
                        this.$message({
                        message: '提交成功！',
                        type: "success",
                        })
                        this.getToDoList();
                        this.dialogFormVisible_resource = false;
                    }                   
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        getSurveyResults(data) {
            // 每次提交记录前，需要重置submit_survey_info，防止连续提交时数据累加导致结果错误
            this.submit_survey_info = [];
            for(var survey in data) {
                var survey_reslut = {};
                survey_reslut['assessee_id'] = this.form['id'];
                survey_reslut['qid'] = data[survey].qid;
                survey_reslut['choice_type'] = data[survey].choice_type;
                survey_reslut['display_num'] = data[survey].display_num;
                survey_reslut['selected_option'] = data[survey].selected_option;
                survey_reslut['proof'] = data[survey].proof;
                survey_reslut['task_id'] = this.form['task_id'];
                this.submit_survey_info.push(survey_reslut);
            }
            this.checkManaSurvey();
            if(this.check_flag_survey == false){
                return;
            }
            
            postdata.postList("submitManaSurvey", JSON.stringify(this.submit_survey_info))
              .then(resp => {
                if(resp.data.code == 200){
                  this.$message({
                    message: resp.data.message,
                    type: "success",
                    })
                  this.dialogFormVisible_survey = false;
                  this.getToDoList();
                }else{
                  this.$message({
                    message: resp.data.message,
                    type: "error",
                    duration: 6000,
                    // showClose: true,
                    })
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        updateToDoNum() {
            // console.log('updateToDoNum-unfinish_num: ' + this.unfinish_num);
            this.$emit('sendToDoNum', this.unfinish_num);
        },
        getToDoList() {
            getdata.getListP("getRCToDoList")
                .then(resp => {
                    if(resp.data.code == 200){
                        this.task_list = resp.data.data;
                        this.unfinish_num = resp.data.unfinish_num;
                        this.updateToDoNum();
                        this.activeNames = this.task_list.map((_, index) => index);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        // 获取RC工作动机问卷     
        getRCMotivation(task_id, row) {
            let r = row || 'none_rows';
            let params = {
                task_id: task_id,
            }
            getdata.getListP("getRCMotivation", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.motivation_info_props = resp.data.data;
                    this.dialogFormVisible = true;
                    if(r != 'none_rows'){
                        this.getResultByUser(task_id);
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        // 获取RC行为问卷
        getRCBehavior(task_id, row) {
            let r = row || 'none_rows';
            let params = {
                task_id: task_id,
            }
            getdata.getListP("getRCBehavior", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.behavior_info = resp.data.data;
                    this.dialogFormVisible_behavior = true;
                    if(r != 'none_rows'){
                        this.getResultByUser(task_id);
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        // 获取RC激励资源问卷
        getRCResource(task_id, row) {
            let r = row || 'none_rows';
            let params = {
                task_id: task_id,
            }
            getdata.getListP("getRCResource", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.resource_info = resp.data.data;
                    this.dialogFormVisible_resource = true;
                    if(r != 'none_rows'){
                        this.getResultByUser(task_id);
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        }, 
        getManaQues(task_id, row) {
            let r = row || 'none_rows';
            let params = {
                task_id: task_id,
            }
            getdata.getListP("getHealthSurvey", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.question_info = resp.data.choice;
                    this.proof_info = resp.data.proof;
                    // console.log("question_info: " + this.question_info);
                    // console.log("proof_info" + this.proof_info);
                    // 获取结果的处理需要放在成功获取到问卷之后，否则会触发获取结果早于获取问卷的情况，导致问卷中无结果信息
                    if(r != 'none_rows'){
                        this.getResultByUser(task_id);
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getManaSurvey(task_id, row) {
            let r = row || 'none_rows';
            let params = {
                task_id: task_id,
            }
            getdata.getListP("getManaSurvey", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.survey_info = resp.data.survey_info;
                    // console.log("survey_info: " + this.survey_info);
                    // 获取结果的处理需要放在成功获取到问卷之后，否则会触发获取结果早于获取问卷的情况，导致问卷中无结果信息
                    if(r != 'none_rows'){
                        this.getResultByUser_survey(r.id, task_id);  
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getResultByUser(task_id) {
            let params;
            params = {
                login_random_series: this.login_random_series,
                task_id: task_id,
            } 
            
            getdata.getListP("getHealthSurveyResult", params)
            .then(resp => {
                if(resp.data.code == 200){
                    var result = resp.data.data;
                    // console.log('result: ' + result + ' ' + result[0]);
                    var i = 0; 
                    // 首先是选择题
                    for(var cg in this.question_info){
                        for(var sj in this.question_info[cg]['subject']){
                            this.question_info[cg]['subject'][sj]['selected_option'] = result[i];
                            i = i + 1;
                        }
                    }
                    // console.log("question_info2: " + this.question_info);
                    // 然后是举证题
                    for(var pf in this.proof_info){
                        this.proof_info[pf]['proof'] = result[i];
                        i = i + 1;
                    }
                    // console.log("proof_info2: " + this.proof_info);
                }
            })
            .catch(err => {
                console.log(err);
            });
        },getResultByUser_survey(assessee_id, task_id) {
            let params;
            params = {
                assessee_id: assessee_id,
                task_id: task_id,
            } 
            
            getdata.getListP("getManaSurveyResults", params)
            .then(resp => {
                if(resp.data.code == 200){
                    let results = resp.data.data;
                    for(var survey in results) {
                        this.survey_info[survey]['assessee_id'] = results[survey]['assessee_id'];
                        this.survey_info[survey]['qid'] = results[survey]['qid'];
                        this.survey_info[survey]['choice_type'] = results[survey]['choice_type'];
                        this.survey_info[survey]['display_num'] = results[survey]['display_num'];
                        this.survey_info[survey]['selected_option'] = results[survey]['selected_option'];
                        this.survey_info[survey]['proof'] = results[survey]['proof'];
                        this.survey_info[survey]['task_id'] = results[survey]['task_id'];
                    }
                    // console.log("survey_info2: " + this.survey_info);
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
    }
};
</script>

<style scoped>
.not_start {
    font-size: 12px;
    background: #fff0f2;
    display: inline-block;
    white-space: nowrap;
    padding: 4.5px 8.5px;
    border-radius: 5px;
    line-height: 1;
    color: #e54c5e;
    border: 1px solid #e54c5e;
}
.in_process {
    font-size: 12px;
    background: #fffaef;
    display: inline-block;
    white-space: nowrap;
    padding: 4.5px 8.5px;
    border-radius: 5px;
    line-height: 1;
    color: #df8d00;
    border: 1px solid #df8d00;
}
.started {
    font-size: 12px;
    background: #FAFFEF;
    display: inline-block;
    white-space: nowrap;
    padding: 4.5px 8.5px;
    border-radius: 5px;
    line-height: 1;
    color: #88C200;
    border: 1px solid #88C200;
}
::v-deep .el-table__header {
    font-size: 14px;
    font-weight: normal;
}
.motivation_dialog /deep/ .el-table__header {
    font-size: 14px;
}
/* .el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
} */
/* ::v-deep .el-dialog {
    height: 600px;
} */
/* 设置dialog的滚动条 */
::v-deep .el-dialog__body {
    max-height: 600px !important;
    min-height: 100px;
    overflow-y: auto;
}
::v-deep .el-collapse-item__header {
    font-size: 18px;
    /* font-weight: bold; */
    color: #409eff;
    padding-left: 20px;
    background-color: #f8f8f8;
    border-bottom: none;
}
::v-deep .el-collapse-item__header.is-active {
    border-bottom: 1px solid #eeeeee;
}
.no_task {
  width: 100%;
  margin: 0 auto;
  color: #909399;
  font-weight: bold;
  height: 60px;
  line-height: 60px;
}
::v-deep .el-dialog__header {
    text-align: left;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
.fade-enter-active, .fade-leave-active {
    transition: opacity 1.5s;
}
::v-deep .el-collapse {
  border: none;
  margin-bottom: 20px;
}
::v-deep .el-collapse-item__wrap {
  border-bottom: none;
}
::v-ddep .el-collapse-item__content {
  padding-bottom: 15px;
}
::v-deep .el-button--mini {
  padding: 4.5px 8.5px;
  border-radius: 5px;
}
::v-deep .el-button--primary {
    background-color: #42b6ff;
    border-color: #42b6ff;
}
.collapse_title {
    display: flex;
    width: 100%;
    align-items: center;
}
.collapse_title .item:last-child {
    margin-left: auto;
}
.el-button[disabled], .el-button.is-disabled {
  background-color: #C0C4CC !important;  /* 禁用态-背景灰（和Element默认一致） */
  border-color: #C0C4CC !important;      /* 禁用态-边框灰（和Element默认一致） */
  color: #FFF !important;                /* 禁用态-文字白（和Element默认一致） */
  cursor: not-allowed !important;        /* 禁用态-鼠标禁止样式（必加） */
  opacity: 0.6 !important;               /* 透明度降低，视觉置灰更明显（推荐加） */
}
</style>